
<style scoped>
.search-area .ipt-sty {
  width: 50%;
}
.filter-wrap {
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-bottom: 20px;
}
.filter-wrap .filter-item {
  display: flex;
  margin-left: 10px;
}
.filter-wrap .filter-item span {
  width: 80px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}
.filter-wrap .filter-item span.active {
  background: #e4f1f2;
  color: #4fa1a4;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.card {
  width: 25%;
  height: 235px;
  margin: 36px 0 0 0;
  border-right: 30px solid #fff;
  box-sizing: border-box;
  position: relative;
}
.card .img-wrap {
  width: 100%;
  height: 140px;
  overflow: hidden;
}
.card .img-wrap img {
  width: 100%;
  height: auto;
}
.distance-time {
  width: 100%;
  height: 40px;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 100px;
  line-height: 40px;
  color: #fff;
}
.distance-time-ing {
  background: rgba(79, 161, 164, 0.7);
  opacity: 0.7;
}
.title-wrap {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
.title-date {
  text-align: left;
}
.title-wrap .title {
  width: 180px;
  font-weight: 500;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.title-wrap .date {
  color: #649fa4;
  font-size: 12px;
}
.title-wrap .state {
  border-radius: 5px;
  background: #e4f1f2;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  color: #4fa1a4;
  width: 60px;
}
.btns {
  padding-left: 10px;
  text-align: left;
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/* .el-range-editor.el-input__inner {
  padding: 0px;
} */
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.state-black {
  font-weight: bold;
  color: rgb(110, 109, 109);
}
.state-green {
  font-weight: bold;
  color: #4fa1a4;
}
.state-orange {
  font-weight: bold;
  color: orange;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management {
  padding: 0 50px;
}
.list-textarea {
  flex: 1;
}
.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
.back-color-fff {
  position: relative;
}
.mange-tep {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 13px;
  color: #4fa1a4;
  font-weight: 500;
  cursor: pointer;
}
/deep/ .el-step__title.is-finish {
  color: #4fa1a4;
}
/deep/ .el-step__head.is-finish {
  color: #4fa1a4;
  border-color: #4fa1a4;
}
/deep/ .is-finish .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #c4c6c9;
}
/deep/ .el-step__head.is-process {
  color: #c4c6c9;
  border-color: #c4c6c9;
}
/deep/ .el-step__icon-inner {
  color: #c4c6c9;
}
/deep/ .parkMeeting .el-dialog__body {
  padding-top: 0;
}

.btnss {
  display: flex;
  justify-content: space-between;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
.search-area-div{
  width: 100px;
}
.ipt-sty{
  flex: 1;
}
.el-col-7 ,.el-col-4{
  display: flex;
  /* margin-bottom: 15px; */
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24" style="display: flex">
        <el-col :span="7"
          ><div class="search-area-div">会议主题：</div>
          <el-input v-model="page.meetingSubject" class="ipt-sty" placeholder="请输入"></el-input
        ></el-col>
        <el-col :span="7">
          <div class="search-area-div">会议发起人：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="7" class="item">
          <div class="search-area-div">开始时间：</div>
          <el-date-picker
            class="ipt-sty"
            v-model="timeRange"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4" class="t-right">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff p16 mt15">
      <div class="filter-wrap">
        <div class="filter-title">安排状态:</div>
        <div class="filter-item">
          <span
            v-for="(item, index) in listTypeList"
            :key="index"
            :class="listType == item.value ? 'active' : ''"
            @click="switchListType(item.value)"
            >{{ item.label }}</span
          >
        </div>
      </div>
      <div class="filter-wrap" style="margin-bottom: 0">
        <div class="filter-title">会议状态:</div>
        <div class="filter-item">
          <span
            v-for="(item, index) in meetingStartStateList"
            :key="index"
            :class="meetingStartState == item.value ? 'active' : ''"
            @click="switchMeetingState(item.value)"
            >{{ item.label }}</span
          >
        </div>
      </div>
      <div
        class="mange-tep"
        @click="
          stepVisible = true;
          stepActive = 1;
        "
      >
        查看会议管理步骤
      </div>
      <div class="wrap">
        <div class="card" v-for="(item, index) in tableData" :key="index">
          <div class="img-wrap">
            <img
              v-if="item.meetingLogo"
              :src="JSON.parse(item.meetingLogo)[0].path"
              alt=""
              srcset=""
              @click.stop.prevent="toLink(item.meetingUrl, item.videoUrl)"
            />
            <img
              v-else
              src="@/assets/images/meeting-default.png"
              alt=""
              srcset=""
              @click.stop.prevent="toLink(item.meetingUrl, item.videoUrl)"
            />
          </div>
          <div class="distance-time" v-if="meetingStartState == 1">距开始还有{{ intervalTime(item.startTime) }}</div>
          <div class="distance-time distance-time-ing" v-if="meetingStartState == 2">进行中</div>
          <div class="distance-time" v-if="meetingStartState == 3">已结束</div>
          <div class="title-wrap">
            <div class="title-date">
              <div class="title">{{ item.meetingSubject }}</div>
              <div class="date">{{ item.startTime | getTime }}</div>
            </div>
            <div class="state" v-if="listType == 1" style="background: #ffe6e5; color: #ff5555">待安排</div>
            <div class="state" v-if="listType == 2">已安排</div>
          </div>
          <div class="btns">
            <span v-if="listType == 1 && item.isMeetingApply == 'Y'"
              @click="detailModify(item.guid, item.tenantGuid)" style="color: #4fa1a4;">预定会议 ｜
            </span>
            <span v-if="item.isMeetingApply == 'Y'" @click="goMeetingPark(item)" style="color: #4fa1a4;">会议管理 ｜ </span>
            <span
              style="color: #4fa1a4;"
              v-if="listType == 2 && meetingStartState != 3 && item.isMeetingApply == 'Y'"
              @click.stop.prevent="toLink(item.meetingUrl, item.videoUrl)"
              >进入会议 ｜
            </span>
            <span
              style="color: #4fa1a4;"
              v-if="listType == 2 && meetingStartState == 3 && item.isMeetingApply == 'Y'"
              @click="detailModifyI(item.guid)"
              >会后资料上传 ｜
            </span>
            <span @click="goMeetingDetail(item)" style="color: #4fa1a4;">会议详情</span>
          </div>
        </div>
      </div>
      <div
        v-if="(tableData && tableData.length == 0) || !tableData"
        class="flex"
        style="text-align: center; margin-top: 40px"
      >
        <img src="@/assets/images/no_data.png" width="283px" height="155px" alt="" srcset="" />
      </div>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[8]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="会后资料上传" :visible.sync="afterMeetingVisible" width="60%">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="会议照片:">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="meetingPhotoList"
            :on-remove="handleMeetingRemove"
            :http-request="uploadMeetingImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="签到表:">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="signFileList"
            :on-remove="handleSignRemove"
            :http-request="uploadSignImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="实际参会人数">
          <el-input class="w420 fl" type="input" v-model="afterPage.realJoinNum"> </el-input>
        </el-form-item>
        <el-form-item label="回放链接">
          <el-input class="w420 fl" type="input" placeholder="请填写回放链接" v-model="afterPage.videoUrl"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="afterMeetingVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="sureAfterUpdate" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="预定会议" custom-class="parkMeeting" :visible.sync="beforeMeetingVisible" width="60%">
      <p
        style="
          text-align: left;
          margin-bottom: 40px;
          font-size: 13px;
          color: #333;
          font-weight: bold;
          padding: 10px;
          background: #eee;
        "
      >
        请先预定会议成功后，下载会议二维码，再制作并上传邀请海报
      </p>
      <el-form label-width="100px" label-position="right" class="demo-ruleForm">
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>选择平台</span></div>
          <el-select class="w420 fl" v-model="beforePage.meetingPlatformGuid" placeholder="请选择平台">
            <el-option
              v-for="item in platformList"
              :key="item.guid"
              :label="item.platformName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </div>
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>会议报名</span></div>
          <el-radio-group v-model="beforePage.isNeedRegister">
            <el-radio label="Y">需要</el-radio>
            <el-radio label="N">不需要</el-radio>
          </el-radio-group>
        </div>

        <div class="input-item" style="align-items: flex-start">
          <div class="input-title"><span>邀请海报</span></div>
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="meetingBillList"
            :on-remove="handleBillRemove"
            :http-request="uploadBillImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </div>
        <div class="input-item" style="align-items: flex-start">
          <div class="input-title"><span>会议封面</span></div>
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="meetingLogoList"
            :on-remove="handleLogoRemove"
            :http-request="uploadLogoImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </div>

        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>客服热线</span></div>
          <el-input class="w420 fl" type="input" placeholder="请填写客服热线" v-model="beforePage.servicePhone">
          </el-input>
        </div>
        <el-form-item label="会议编号">
          <el-input class="w420 fl" type="input" placeholder="请填写会议编号" v-model="beforePage.meetingNo">
          </el-input>
        </el-form-item>
        <el-form-item label="会议链接">
          <el-input class="w420 fl" type="input" placeholder="请填写会议链接" v-model="beforePage.meetingUrl">
          </el-input>
        </el-form-item>
        <div class="management-list" style="margin-left: 28px">
          <div class="management-name">会议可见部门：</div>
          <div>
            <span
              class="designee mb10"
              v-show="departmentData !== '' || departmentData !== null"
              v-for="(item, index) in departmentData"
              :key="index"
              ><span class="select-name">{{ item.organisationName }}</span>
              <span @click="delDepartmentSingle(index)" class="ml10 cursor-sty font-S19">×</span></span
            >
            <span class="select-department" @click="visible3 = true">{{
              departmentData && departmentData.length > 0 ? '修改' : '选择部门'
            }}</span>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="beforeMeetingVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="sureBeforeUpdate" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick1"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              v-loading="tableLoading"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="stepVisible" title="会议管理步骤" width="50%" center>
      <div style="text-align: center">
        <el-steps :active="stepActive" align-center>
          <el-step title="会议详情"></el-step>
          <el-step title="预定会议"></el-step>
          <el-step title="安排会议"></el-step>
          <el-step title="会后资料上传"></el-step>
        </el-steps>
        <img v-if="stepActive == 1" src="@/assets/images/steps/step1.png" width="356" height="333" />
        <img v-if="stepActive == 2" src="@/assets/images/steps/step2.png" width="356" height="333" />
        <img v-if="stepActive == 3" src="@/assets/images/steps/step3.png" width="356" height="333" />
        <img v-if="stepActive == 4" src="@/assets/images/steps/step4.png" width="356" height="333" />
        <div class="btnss">
          <div>
            <el-button class="btn" @click="prev">上一步</el-button>
          </div>
          <div>
            <el-button v-if="stepActive == 4" class="btn" @click="stepVisible = false">关闭</el-button>
            <el-button v-else class="btn" @click="next">下一步</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
export default {
  data() {
    return {
      stepActive: 1,
      stepVisible: false,
      timeRange: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '近三日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '近一月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },

      page: {
        pageIndex: 1,
        pageSize: 8,
        totalPage: 0,
        totalRows: 0,
        staffGuid: '',
        startTime: '',
        endTime: '',
        meetingSubject: '',
        listType: '',
        staffName: '',
      },

      listTypeList: [
        { value: 1, label: '待安排' },
        { value: 2, label: '已安排' },
      ],
      meetingStartStateList: [
        { value: 1, label: '未开始' },
        { value: 2, label: '已开始' },
        { value: 3, label: '已结束' },
      ],
      meetingStartState: 1,
      listType: 1,
      fullscreenLoading: false,
      tableData: [],

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.token,
      },

      afterMeetingVisible: false,
      meetingPhotoList: [],
      signFileList: [],
      afterPage: {
        videoUrl: '',
        realJoinNum: '',
        signFile: [],
        meetingPhoto: [],
      },

      guid: '',
      beforeMeetingVisible: false,
      platformList: [],
      meetingBillList: [], //海报
      meetingLogoList: [], //封面
      beforePage: {
        meetingBill: [],
        meetingLogo: [],
        meetingUrl: '', //会议链接
        servicePhone: '', //客服热线
        isNeedRegister: 'Y', //是否需要报名
        meetingPlatformGuid: '', //平台id
        meetingPlatformName: '', //平台名称
        meetingNo: '', //会议编号
      },
      tableLoading: false,
      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getPlatform();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  activated() {
    this.getData(false);
  },
  methods: {
    prev() {
      var stepActive = this.stepActive - 1;
      if (stepActive == 0) return;
      this.stepActive = stepActive;
    },
    next() {
      var stepActive = this.stepActive + 1;
      if (stepActive == 5) return;
      this.stepActive = stepActive;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    getPlatform() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        isOpen: '1',
        platformUse: 0,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/get-list`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.platformList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //安排状态
    switchListType(val) {
      this.listType = val;
      this.page.listType = val;
      this.page.meetingStartState = this.meetingStartState;
      this.tableData = [];
      this.getData(true);
    },
    //会议状态
    switchMeetingState(val) {
      this.meetingStartState = val;
      this.page.meetingStartState = val;
      this.page.listType = this.listType;
      this.tableData = [];
      this.getData(true);
    },

    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 8,
        totalPage: 0,
        totalRows: 0,
        staffGuid: '',
        startTime: '',
        endTime: '',
        meetingSubject: '',
        listType: '',
        staffName: '',
      };
      self.timeRange = '';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      self.page.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      self.page.meetingStartState = self.meetingStartState;
      self.page.listType = self.listType;
      self.fullscreenLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/meeting/data/get-meeting-list-company`, self.page)
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data !== null) {
              self.tableData = res.data.data.records;
              self.page.totalPage = res.data.data.totalPages;
              self.page.totalRows = res.data.data.totalRows;
            } else {
              self.tableData = [];
              self.page.totalPage = 0;
              self.page.totalRows = 0;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    intervalTime(endTime) {
      var date1 = new Date(); //开始时间
      var date2 = new Date(endTime); //结束时间
      var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
      //计算出相差天数
      var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数

      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));

      //计算相差秒数

      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return days + '天' + hours + '小时' + minutes + '分钟';
    },
    goMeetingPark(item) {
      this.$router.push({
        path: '/meetingPark',
        query: {
          guid: item.guid,
          listType: this.listType,
        },
      });
    },
    //会议详情
    goMeetingDetail(item) {
      this.$router.push({
        path: '/meetingDetailNew',
        query: {
          guid: item.guid,
          tenantName: item.tenantName,
          meetingState: item.meetingState !== null ? item.meetingState : '未开始',
          meetingTimeLong: item.meetingTimeLong,
          meetingStartState: this.meetingStartState,
          listType: this.listType,
          isMeetingApply:item.isMeetingApply
        },
      });
    },
    //进入会议
    toLink(meetingUrl, videoUrl) {
      var url = '';
      if (this.meetingStartState == 1 || this.meetingStartState == 2) {
        url = meetingUrl;
      } else {
        url = videoUrl;
      }
      if (url) {
        url = url.match(/[a-zA-z]+:\/\/[^\s]*/gi)[0];
        window.open(url);
      } else {
        this.$message({
          message: '暂无链接！',
          type: 'error',
        });
      }
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    //安排会议
    detailModify(guid, tenantGuid) {
      this.guid = guid;
      this.meetingBillList = []; //海报
      this.meetingLogoList = []; //封面
      this.beforePage = {
        meetingBill: [],
        meetingLogo: [],
        meetingUrl: '', //会议链接
        servicePhone: '', //客服热线
        isNeedRegister: 'Y', //是否需要报名
        meetingPlatformGuid: '', //平台id
        meetingPlatformName: '', //平台名称
        meetingNo: '', //会议编号
      };
      this.area = [];
      this.departmentList = [];
      this.departmentData = '';
      this.areaData = [];
      this.delList = [];
      this.filterText = '';
      this.beforeMeetingVisible = true;
      this.getOrganisation(tenantGuid);
    },
    detailModifyI(guid) {
      var self = this;
      this.guid = guid;
      this.meetingPhotoList = [];
      this.signFileList = [];
      self.api
        .postCan(`/${serverConfig.msSalesPerformService}/flow/data/get-online-meeting-detail?guid=` + guid)
        .then((res) => {
          var item = res.data.data;

          if (item.signFile) {
            var signFile = JSON.parse(item.signFile);
            signFile.forEach((el) => {
              self.signFileList.push({
                name: '会议照片',
                url: el.path,
              });
            });
          }
          if (item.meetingPhoto) {
            var meetingPhoto = JSON.parse(item.meetingPhoto);
            meetingPhoto.forEach((el) => {
              self.meetingPhotoList.push({
                name: '会议照片',
                url: el.path,
              });
            });
          }

          this.afterPage.realJoinNum = item.realJoinNum;
          this.afterPage.videoUrl = item.videoUrl;
          this.afterMeetingVisible = true;
          this.$forceUpdate();
        });
    },
    sureAfterUpdate() {
      this.afterPage.meetingPhoto = [];
      this.afterPage.signFile = [];
      var meetingPhotoList = this.meetingPhotoList;
      var signFileList = this.signFileList;
      var self = this;
      var req = {
        dataType: 2,
        guid: self.guid,
        meetingOpenId: JSON.parse(localStorage.userInfo).weChatOpentId,
      };
      if (meetingPhotoList.length != 0) {
        meetingPhotoList.forEach((item, index) => {
          this.afterPage.meetingPhoto.push({
            fileName: `会议照片_` + index,
            path: item.url,
          });
        });
      }
      if (signFileList.length != 0) {
        signFileList.forEach((item, index) => {
          this.afterPage.signFile.push({
            fileName: `签到表_` + index,
            path: item.url,
          });
        });
      }
      if (this.afterPage.meetingPhoto.length != 0) {
        req.meetingPhoto = JSON.stringify(this.afterPage.meetingPhoto);
      } else {
        req.meetingPhoto = '';
      }
      if (this.afterPage.signFile.length != 0) {
        req.signFile = JSON.stringify(this.afterPage.signFile);
      } else {
        req.signFile = '';
      }
      req.videoUrl = this.afterPage.videoUrl;
      req.realJoinNum = this.afterPage.realJoinNum;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/data/edit-meeting-info`, req).then((res) => {
        self.fullscreenLoading = false;
        self.afterMeetingVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('会后资料上传成功！');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    /** 邀请海报 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.meetingBillList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingBillList.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '邀请海报',
              url: res.data.data,
            };
            self.meetingBillList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /** 会议海报 上传相关 结束*/

    /** 会议封面 上传相关 开始*/
    handleLogoRemove(file) {
      let self = this;
      self.meetingLogoList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingLogoList.splice(ind, 1);
        }
      });
    },
    uploadLogoImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '会议封面',
              url: res.data.data,
            };
            self.meetingLogoList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /** 会议封面 上传相关 结束*/

    sureBeforeUpdate() {
      this.beforePage.meetingBill = [];
      this.beforePage.meetingLogo = [];
      var meetingBillList = this.meetingBillList;
      var meetingLogoList = this.meetingLogoList;
      var self = this;
      var req = {
        dataType: 3,
        guid: self.guid,
        meetingOpenId: JSON.parse(localStorage.userInfo).weChatOpentId,
      };

      if (!this.beforePage.meetingPlatformGuid) {
        self.$message.error('请选择会议平台！');
        return;
      }
      if (!this.beforePage.isNeedRegister) {
        self.$message.error('请选择会议是否需要报名！');
        return;
      }
      // if (meetingBillList.length == 0) {
      //   self.$message.error('请上传邀请海报！');
      //   return;
      // }

      if (!this.beforePage.servicePhone) {
        self.$message.error('请输入客服热线！');
        return;
      }
      // if (!this.beforePage.meetingNo) {
      //   self.$message.error('请输入会议编号！');
      //   return;
      // }
      // if (!this.beforePage.meetingUrl) {
      //   self.$message.error('请输入会议链接！');
      //   return;
      // }

      if (meetingBillList.length != 0) {
        meetingBillList.forEach((item, index) => {
          this.beforePage.meetingBill.push({
            fileName: `邀请海报_` + index,
            path: item.url,
          });
        });
      }
      if (meetingLogoList.length != 0) {
        meetingLogoList.forEach((item, index) => {
          this.beforePage.meetingLogo.push({
            fileName: `会议封面_` + index,
            path: item.url,
          });
        });
      }
      if (this.beforePage.meetingBill.length != 0) {
        req.meetingBill = JSON.stringify(this.beforePage.meetingBill);
      }
      if (this.beforePage.meetingLogo.length != 0) {
        req.meetingLogo = JSON.stringify(this.beforePage.meetingLogo);
      }
      if (this.departmentData !== '') {
        var departmentData = [];
        self.departmentData.forEach((item) => {
          departmentData.push(item.guid);
        });
        req.organisationGuids = departmentData;
      }
      this.platformList.forEach((item) => {
        if (item.guid == this.beforePage.meetingPlatformGuid) {
          req.meetingPlatformName = item.platformName;
        }
      });
      req.meetingUrl = this.beforePage.meetingUrl;
      req.servicePhone = this.beforePage.servicePhone;
      req.isNeedRegister = this.beforePage.isNeedRegister;
      req.meetingPlatformGuid = this.beforePage.meetingPlatformGuid;
      req.meetingNo = this.beforePage.meetingNo;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/data/edit-meeting-info`, req).then((res) => {
        self.fullscreenLoading = false;
        self.beforeMeetingVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('安排会议成功！');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    /** 会议照片 上传相关 开始*/
    handleMeetingRemove(file) {
      let self = this;
      self.meetingPhotoList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingPhotoList.splice(ind, 1);
        }
      });
    },
    uploadMeetingImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '会议照片',
              url: res.data.data,
            };
            self.meetingPhotoList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /** 会议照片 上传相关 结束*/

    /** 签到表 上传相关 开始*/
    handleSignRemove(file) {
      let self = this;
      self.signFileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.signFileList.splice(ind, 1);
        }
      });
    },
    uploadSignImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          console.log(res);
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '签到表',
              url: res.data.data,
            };
            self.signFileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },

    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      let item = {
        guid: data.guid,
        organisationName: data.organisationName,
      };
      self.area.push(JSON.stringify(item));
      self.area = self.unique(self.area);
      self.departmentList = [];
      self.area.forEach(function (i) {
        self.departmentList.push(JSON.parse(i));
      });
      console.log(self.departmentData);
    },
    //确定选择部门
    departmentSure() {
      this.departmentData = this.departmentList;
      console.log(this.departmentData);
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      // this.departmentList.splice(index,1)
    },
  },
};
</script> 
